import { Button, EmptyState } from '@alicerce/ui';
import { isRouteErrorResponse, useRouteError } from 'react-router';

/** Erro inesperado numa tela: mensagem em português e um jeito de seguir. */
export function RouteError() {
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  return (
    <div className="py-16">
      <EmptyState
        title={notFound ? 'Página não encontrada' : 'Algo deu errado nesta tela'}
        description={notFound ? 'Confira o endereço ou volte para o início.' : 'Já registramos o problema. Recarregue a página ou volte para o início.'}
        action={
          <div className="flex gap-2">
            {!notFound && <Button onClick={() => window.location.reload()}>Recarregar</Button>}
            <Button variant="secondary" onClick={() => window.location.assign('/')}>
              Ir para o início
            </Button>
          </div>
        }
      />
    </div>
  );
}

export function NotFoundPage() {
  return <EmptyState title="Página não encontrada" description="Confira o endereço ou volte para o início." />;
}
